import React, { useEffect, useReducer, useState } from "react";

import {
  ifscRegex,
  bankAccountRegex,
  pincodeRegex,
  nameRegex,
  accountRegex,
} from ".";

import CustomizedSelect from "../customizedSelect";
import { Input } from "../../../forms/input";
import CustomLoader from "../../../forms/Loader";
import CardComponent from "./lib/CardComponent";
import { MenuItem } from "@material-ui/core";
import { getBankDetails } from "../../../../store/actions/newinvestor";
import {
  getBankList,
  storeInvestmentDetails,
  storeInvestmentParams,
  NewinvestorBankDetails,
  bankAccountTypes,
  storeApplicantParams,
  getAccountTypes
} from "../../../../store/actions";
import { connect } from "react-redux";
import { validatePennyDrop } from "../../../../store/actions";

const BankDetails = (props) => {
  // const ValidAccountTypes = {
  //   11: ["Savings"],
  //   12: ["Current"],
  //   21: ["NRE"],
  //   22: ["NRO"],
  // };
  const InputFields = [
    [
      { name: "IFSC", isMandatory: true, type: "text" },
      { name: "Account Type", isMandatory: true },
    ],
    [
      // { name: "MICR Code", isMandatory: false, type: "text" },
      { name: "Bank Name", isMandatory: true, type: "text" },
      { name: "Branch Address", isMandatory: true, type: "text" },
    ],
    [
      { name: "Branch City", isMandatory: true, type: "text" },
      { name: "Branch Pincode", isMandatory: true, type: "number" },
    ],
    [
      { name: "Account Number", isMandatory: true, type: "password" },
      { name: "Confirm Account Number", isMandatory: true, type: "number" },
    ],
  ];
  const [bankselected, setbankseleected] = useState("");
  const [bankList, setBankList] = useState([]);

  const initialState = {
    IFSC: { value: "" },
    // "MICR Code": { value: "" },
    "Bank Name": { value: "" },
    "Branch Address": { value: "" },
    "Branch City": { value: "" },
    "Branch Pincode": { value: "" },
    "Account Type": { value: "" },
    "Account Number": { value: "" },
    "Confirm Account Number": { value: "" },
    AccountTypes: [],
    isLoading: false,
    BanksListShow: true,
  };
  const [formValues, setFormValues] = useReducer(
    (preValues, newValues) => ({ ...preValues, ...newValues }),
    initialState
  );

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    NewinvestorBankDetails();
    const { investmentDetails } = props;
    if (investmentDetails.IFSC) {
      setFormValues({ ...investmentDetails });
      return;
    }
    // setFormValues({
    //   AccountTypes: ValidAccountTypes[props.applicantparams.i_category],
    //   "Account Type": {
    //     value: ValidAccountTypes[props.applicantparams.i_category]
    //   },
    // });
  }, []);
  const NewinvestorBankDetails = async () => {
    const response = await props.NewinvestorBankDetails({
      pan: props.applicantparams.i_pangno,
      // pan:"ABAPM0703H"
    });
    const banks = !!response.Dtinformation ? response.Dtinformation : [];
    if(!!response && banks[0]){
      const bankDetails= banks[0]
      setFormValues({
        bankadd1: bankDetails.BankAdd1,
        bankadd2: bankDetails.BankAdd2,
        bankadd3: bankDetails.BankAdd3,
        IFSC: { value: bankDetails.ifsccode },
        "Bank Name": { value: bankDetails.BankName },
        "Branch Address": {
          value:
            bankDetails.BankAdd1 +
            ", " +
            bankDetails.BankAdd2 +
            " ," +
            bankDetails.BankAdd3,
        },
        "Branch City": { value: bankDetails.BankCity },
        "Branch Pincode": { value: bankDetails.BankPIN },
        "Account Number": { value: bankDetails.BankAcno },
        "Confirm Account Number": { value: bankDetails.BankAcno },
        "Account Type": {
          value: bankDetails.BnkAcType,
        },
        // value: ValidAccountTypes[bankDetails.BnkAcType]
      });
  
    }
    if (response.Dtinformation.length === 0) {
      setFormValues({ BanksListShow: false });
    }
    const bankList = banks.map((bank) => {
      return { label: bank.BankName, value: bank.BankName };
    });
    setBankList(bankList);
    const params = {
      opt: "AC",
      SchemeType: props.applicantparams.i_category === "20" ? 'Y' : "",
    }
    const res = await props.getAccountTypes(params)
    if (res) {
      const typeList = res.Dtinformation.map((type) => {
        return { label: type.Account_Type, value: type.Account_Type };
      });
      setFormValues({ AccountTypes: typeList });
    }
  };

  const handleChange = (label) => (event) => {
    const value = event.target.value;
    switch (label) {
      case "IFSC":
        setFormValues({
          [label]: {
            value: value.toUpperCase(),
            isError: !ifscRegex.test(value),
            errorMessage: !value
              ? "IFSC Number is Mandatory"
              : !ifscRegex.test(value)
                ? "Enter a valid IFSC Number"
                : "",
          },
        });
        break;
      case "Account Type":
        setFormValues({
          [label]: {
            value: value,
            isError: value ? false : true,
            errorMessage: value ? "" : "Enter a valid Account Typ",
          },
        });
        break;
      case "Branch Pincode":
        setFormValues({
          [label]: {
            value,
            isError: !pincodeRegex.test(value),
            errorMessage: !value
              ? "Pincode is Mandatory"
              : !pincodeRegex.test(value)
                ? "Enter a valid Pincode"
                : "",
          },
        });
        break;
      case "Account Number":
        setFormValues({
          [label]: {
            value,
            isError: !bankAccountRegex.test(value),
            errorMessage: !value
              ? "Account Number is Mandatory"
              : !bankAccountRegex.test(value)
                ? "Enter a valid Account Number"
                : "",
          },
        });
        break;
      case "Confirm Account Number":
        setFormValues({
          [label]: {
            value,
            isError: !(formValues["Account Number"].value === value),
            errorMessage: !value
              ? "Account Number is Mandatory"
              : !(formValues["Account Number"].value === value)
                ? "Account Numbers does not match"
                : "",
          },
        });
        break;
      default:
        setFormValues({ [label]: { value } });
        break;
    }
  };
  const getBankDetails = async () => {
    const { IFSC } = formValues;
    if (ifscRegex.test(IFSC.value)) {
      setFormValues({ isLoading: true });
      try {
        const response = await props.getBankDetails({ ifsc: IFSC.value });
        const { DtData } = response;
        const {
          BankName,
          BankAdd1,
          BankAdd2,
          BankAdd3,
          BankCity,
          BankPin,
          MicrNo,
        } = DtData[0];
        setFormValues({
          bankadd1: BankAdd1,
          bankadd2: BankAdd2,
          bankadd3: BankAdd3,
          "Bank Name": { value: BankName },
          "Branch Address": {
            value: BankAdd1 + ", " + BankAdd2 + " ," + BankAdd3,
          },
          "Branch City": { value: BankCity },
          "Branch Pincode": { value: BankPin },
          // "MICR Code": { value: MicrNo },
          "Account Number":{value:""},
          "Confirm Account Number":{value:""},
        });
      } catch (error) {
        console.log(error);
        setFormValues({
          ...initialState,
          // AccountTypes: ValidAccountTypes[props.category_1],
          // "Account Type": {
          //   value: ValidAccountTypes[props.category_1],
          // },
          IFSC: {
            value: "",
            isError: true,
            errorMessage: "IFSC Not Found, Enter a valid IFSC Number",
          },
        });
      } finally {
        setFormValues({ isLoading: false });
      }
    } else {
      setFormValues({
        IFSC: {
          value: IFSC.value,
          isError: true,
          errorMessage: !IFSC.value
            ? "IFSC Number is Mandatory"
            : "Enter a valid IFSC Number",
        },
      });
    }
  };
  const handleBankDetails = (event) => {
    setbankseleected(event.target.value);
    const bankDetails =
      !!props.getbankDetails.Dtinformation &&
      props.getbankDetails.Dtinformation.find(
        (ele) => ele.BankName === event.target.value
      );
    setFormValues({
      bankadd1: bankDetails.BankAdd1,
      bankadd2: bankDetails.BankAdd2,
      bankadd3: bankDetails.BankAdd3,
      IFSC: { value: bankDetails.ifsccode },
      "Bank Name": { value: bankDetails.BankName },
      "Branch Address": {
        value:
          bankDetails.BankAdd1 +
          ", " +
          bankDetails.BankAdd2 +
          " ," +
          bankDetails.BankAdd3,
      },
      "Branch City": { value: bankDetails.BankCity },
      "Branch Pincode": { value: bankDetails.BankPIN },
      "Account Number": { value: bankDetails.BankAcno },
      "Confirm Account Number": { value: bankDetails.BankAcno },
      "Account Type": {
        value: bankDetails.BnkAcType,
      },
      // value: ValidAccountTypes[bankDetails.BnkAcType]
    });
  };

  const submit = async () => {
    if(!!formValues.IFSC.value && !formValues["Account Type"].value ){
      setFormValues({
        ...formValues,
       "Account Type": {
          value: "",
          isError: true,
          errorMessage: "Account Type is mandatory",
        },
      });
      return;
    }
    if (props.applicantparams["i_category"] === "20" && ["SAVING", "Savings", "Saving","SAVINGS"].includes(formValues["Account Type"].value)) {
          setFormValues({
        ...formValues,
       "Account Type": {
          value: "",
          isError: true,
          errorMessage: "Select account type",
        },
      });
      return;

    }
    const { AccountTypes, isLoading, bankadd1, bankadd2, bankadd3, ...others } =
      formValues;
    const invdetails = {
      i_ifsccode: formValues.IFSC.value,
      // i_micrcode: formValues["MICR Code"].value,
      i_bnkacname: formValues["Bank Name"].value,
      i_bnkadd1: formValues.bankadd1,
      i_bnkadd3: formValues.bankadd3,
      i_bnkadd2: formValues.bankadd2,
      i_bnkcity: formValues["Branch City"].value,
      i_bnkpin: formValues["Branch Pincode"].value,
      i_bnkacctype: formValues["Account Type"].value,
      i_bnkacno: formValues["Account Number"].value,
    };
    if (formValues["Account Type"].value === "NRE") {
      props.applicantparams["i_category"] = "21"
      props.storeApplicantParams(props.applicantparams);
    }
    if (formValues["Account Type"].value === "NRO") {
      props.applicantparams["i_category"] = "22"
      props.storeApplicantParams(props.applicantparams);
    }
    props.storeInvestmentDetails({ ...formValues });
    props.storeInvestmentParams({ ...invdetails });
    props.history.replace("/new-investor-transaction/scheme-details");
  };
  const { AccountTypes, isLoading } = formValues;
  return (
    <>
      <span
        className="container-margin"
        style={{ fontSize: "18px", fontWeight: "800", color: "#033f7c" }}
      >
        BANK Details
      </span>
      <CardComponent title="Account Details">
        <CustomLoader display={isLoading} />
        {/* {formValues.BanksListShow && (
          <div className="fatca-input-margin">
            <CustomizedSelect
              fatcawidth={true}
              name="Banks*"
              value={bankselected}
              handleChange={handleBankDetails}
            >
              {bankList.map((item, index) => (
                <MenuItem value={item.value} key={index}>
                  {item.value}
                </MenuItem>
              ))}
            </CustomizedSelect>
          </div>
        )} */}

        {InputFields.map((section) => (
          <div className="flex">
            {section.map((field) => (
              <div
                className="input-margin-investor-flow appbar-div dual-margin"
                onClick={() => console.log(field)}
              >
                {!!field.type ? (
                  <div>
                  <Input
                    name={field.name}
                    image="/images/nav.png"
                    isMandatory={field.isMandatory}
                    type={field.type}
                    value={formValues[field.name].value}
                    onChange={handleChange(field.name)}
                    pattern={field.pattern}
                    onBlur={
                      field.name === "IFSC"
                        ? getBankDetails
                        : handleChange(field.name)
                    }
                    isError={formValues[field.name].isError}
                    isShowError={formValues[field.name].isError}
                    errorMessage={formValues[field.name].errorMessage}
                    id={`${field.name}Field`}
                    width={field.width || ""}
                  />
                   <span style={{color:"grey",fontWeight:"900"}}>
                   {field.name === "IFSC" && 
                   "*To add new bank, enter IFSC of the new bank account."
                    }
                 </span>
                  </div>
                ) : (
                  <CustomizedSelect
                    name={field.name}
                    isMandatory={field.isMandatory}
                    value={formValues[field.name].value}
                    isError={formValues[field.name].isError}
                    errorMessage={formValues[field.name].errorMessage}
                    handleChange={handleChange(field.name)}
                    placeholder={`Select ${field.name}`}
                    id={`${field.name}Field`}
                    disabled={field.disabled}
                  >
                    {AccountTypes.map((i, index) => (
                      <MenuItem value={i.value} key={index}>
                        {i.label}
                      </MenuItem>
                    ))}
                  </CustomizedSelect>
                )}
              </div>
            ))}
          </div>
        ))}
        <></>
      </CardComponent>

      <div className="d-flex justify-content-end">
        <button
          className="new-investor-button new-investor-active"
          style={{ filter: "grayscale(1) opacity(0.4)" }}
          onClick={() =>
            props.history.replace("/new-investor-transaction/nominee-details")
          }
        >
          BACK
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          PROCEED
        </button>
      </div>
    </>
  );
};
export default connect(
  ({ newinvestor }) => {
    const { investmentDetails, applicantparams, getbankDetails } = newinvestor;
    return {
      investmentDetails,
      applicantparams,
      getbankDetails,
    };
  },
  {
    getBankDetails,
    storeInvestmentDetails,
    storeInvestmentParams,
    validatePennyDrop,
    storeApplicantParams,
    getBankList,
    NewinvestorBankDetails,
    bankAccountTypes,
    getAccountTypes
  }
)(BankDetails);
